import React, { memo, useCallback, useState } from 'react';
import { Button, Card, Dropdown, List, Menu, Typography } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { capitalize } from '@/utils';
import { NotificationTemplateVariable } from '@/graphql/generated/graphql';
import { ObjKeyT } from '@/types';

type Props = {
  onAddVariable: (variable: string) => void;
  variables?: NotificationTemplateVariable[];
};

const VariableSelect = memo<Props>(({ onAddVariable, variables }) => {
  const [activeTab, setActiveTab] = useState('name');
  const [dropDownVisible, setDropDownVisible] = useState(false);

  const onTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  const onSelectVariable = useCallback(
    (e: React.SyntheticEvent<HTMLElement>) => {
      if (e && e.currentTarget.textContent) {
        onAddVariable(e.currentTarget.textContent);
        setDropDownVisible(false);
      }
    },
    [onAddVariable]
  );

  const getSteps = (activeTab: string) => {
    const steps: ObjKeyT<React.ReactNode> = {};
    const filteredVariables = variables?.filter((variable) => variable.name === activeTab);
    const dataSource = filteredVariables?.map((variable) => {
      return {
        title: capitalize(variable.name),
        variable: `{{${variable.name}}}`,
      };
    });

    variables?.forEach((variable) => {
      steps[variable.name] = (
        <List
          size="small"
          header={<Typography.Text type="secondary">Basic</Typography.Text>}
          dataSource={dataSource}
          renderItem={(item) => {
            return (
              <List.Item
                extra={
                  <Button key={item.variable} value={item.variable} type="link" onClick={onSelectVariable}>
                    {item.variable}
                  </Button>
                }
              >
                {item.title}
              </List.Item>
            );
          }}
        />
      );
    });

    return steps;
  };

  const cardTabs = variables?.map((variable) => {
    return {
      key: variable.name,
      tab: capitalize(variable.name),
    };
  });

  return (
    <Dropdown
      onOpenChange={setDropDownVisible}
      open={dropDownVisible}
      overlay={
        <Menu>
          <Card tabList={cardTabs} activeTabKey={activeTab} onTabChange={onTabChange} bordered={false}>
            {getSteps(activeTab)[activeTab]}
          </Card>
        </Menu>
      }
    >
      <Button type="primary">
        Insert Variable <DownOutlined />
      </Button>
    </Dropdown>
  );
});

export default VariableSelect;
